import { ServiceConsts } from "./ServiceConsts";

export class AnalyticsService {
    static async trackEvent(userId, email, eventName) {
        // send post request to analytics service with json body
        // containing user id, email, and event name
        const response = await fetch(
            `${ServiceConsts.ANALYTICS_URL}/trackEvent`,
            {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    user_id: userId,
                    email: email,
                    event_name: eventName,
                }),
            },
        );

        // analytics server returns empty body and 200 status code if successful
        if (response.ok) return true;
        else throw { isError: true, error: response };
    }
    
}
